import script from "./PatientGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientGeneral.vue?vue&type=script&setup=true&lang=js"

import "./PatientGeneral.vue?vue&type=style&index=0&id=924f57d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-924f57d8"]])

export default __exports__